export const CAMPAIGN_FETCH_START = 'CAMPAIGN_FETCH_START';
export const CAMPAIGN_FETCH_SUCCESS = 'CAMPAIGN_FETCH_SUCCESS';
export const CAMPAIGN_FETCH_FAIL = 'CAMPAIGN_FETCH_FAIL';
export const CAMPAIGN_RESET = 'CAMPAIGN_RESET';
